import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DurationRange } from '@app-core/models/core.model';
import { DateService } from '@app-core/services/date/date.service';
import { getDurationFilterState, getVideoRequestTags, State } from '@app-dvr/reducers';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
@Component({
  selector: 'app-page-filter',
  templateUrl: './page-filter.component.html',
  styleUrls: ['./page-filter.component.scss'],
})
export class PageFilterComponent implements OnInit, OnDestroy {
  @Output()
  public changeDuration = new EventEmitter<any>();

  public durationRange: DurationRange;
  public form = null;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public isTouchDevice = false;
  public entityType = ['asset', 'driver', 'dvr-video'];
  private ngUnsubscribeOnChanges: Subject<void> = new Subject<void>();
  public videoRequestTags: any[];
  public tagIds = [];

  constructor(
    private store: Store<State>,
    private fb: FormBuilder,
    private dateService: DateService,
    public translate: TranslateService,
    private mixpanelService: MixPanelService
  ) {}

  public ngOnInit() {
    const d = new Date();
    const defaultStartDate = new Date(d.setDate(d.getDate() - 7));

    this.form = this.fb.group({
      days: [7, Validators.required],
      startDate: [defaultStartDate, [Validators.required]],
      endDate: [new Date(), [Validators.required]],
      tagIds: [],
    });

    this.store
      .select(getDurationFilterState)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((durationFilter) => {
        const { days, displayStartDate: startDate, displayEndDate: endDate } = durationFilter;
        this.durationRange = { days, startDate, endDate };
        this.form.patchValue({
          ...this.durationRange,
          tagIds: durationFilter.tagIds,
        });
      });

    this.store
      .select(getVideoRequestTags)
      .pipe(takeUntil(this.ngUnsubscribeOnChanges))
      .subscribe((tagFilter) => {
        const { tagIds } = tagFilter;
        this.tagIds = tagIds;
      });
    this.videoRequestTags = this.tagIds.length ? this.tagIds.map((tagid) => ({ tagId: tagid })) : [];
  }

  public durationChange(durationRange: DurationRange) {
    const { days, startDate, endDate } = durationRange;
    if (days && startDate && endDate) {
      this.form?.patchValue({
        days: days,
        startDate: startDate,
        endDate: endDate,
      });
    }
  }
  /**
   * Function called on click of search button
   *
   * Emit search event.
   */
  public onSearch() {
    const { days, startDate, endDate, tagIds } = this.form.value;
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliSeconds = now.getMilliseconds();

    // Setting current Hours, minutes and seconds since datepicker only sets date part.
    const from = this.dateService.toDaysStartISO(new Date(startDate.setHours(hours, minutes, seconds, milliSeconds)));
    const to = this.dateService.toDaysEndISOPlusOne(new Date(endDate.setHours(hours, minutes, seconds, milliSeconds)));
    this.mixpanelService.track('Click search - Video Requests Page', {
      'Days Selected': days,
      'Start Date': from,
      'End Date': to,
      'Tag Ids': tagIds,
    });
    this.changeDuration.emit({
      days: days,
      displayStartDate: startDate,
      displayEndDate: endDate,
      paramStartDate: from,
      paramEndDate: to,
      tagIds: tagIds,
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.ngUnsubscribeOnChanges.next();
    this.ngUnsubscribeOnChanges.complete();
  }

  public selectedTags(tags) {
    this.form.get('tagIds').patchValue(tags);
  }
}
